/**
 * Enumeracion para las razones de generacion de un token de contraseña
 */
export enum UserTokenGenerationReasons {
 PasswordForgotten = 'PasswordForgotten',
 ChangePassword = 'ChangePassword'
}

/**
 * Modelo para el resultado de la validacion de un token para renovar la contraseña,
 * que contiene el usuario que lo generó y el motivo
 */
export interface UserTokenValidationResult {
	userName: string;
	action: string;
}

/**
 * Modelo para los tokens de sesion
 */
export class TokenInfo {
	public userId: number;
	public userName: string;
	public email: string;
	public token: string;
	public language: string;
	public rtoken?: string;
	public isIpmConfigured: boolean;
	public company: string;
	public roleDescription: Array<string>;
	public roleName: Array<string>
	public firstName: string;
	public lastName: string;
	public customerId: number;
	public isOnlyPremium: boolean;
	public isTravelAgency: boolean;
	public isWelcomeMessageRead: boolean;
	public code: string;
	public qr: string;
  public isMfaReset: boolean;
}
